// Sortierbare Tabellen: table[data-sortable], sortierbare Spalten mit th[data-sort="text"]
// oder "number". Der Spaltenkopf wird zum Knopf (Tastatur), aria-sort nennt die Richtung.
// Werte kommen aus data-sort-value der Zelle, sonst aus ihrem Text; leere Werte stehen
// immer unten. Zahlen zuerst absteigend, Texte zuerst aufsteigend. Ohne JavaScript bleibt
// die Reihenfolge der Seite.
export default function sortTables() {
  document.querySelectorAll('table[data-sortable]').forEach(function (table) {
    const head = table.tHead && table.tHead.rows[0];
    const body = table.tBodies[0];
    if (!head || !body) return;
    const headers = Array.from(head.cells);
    const collator = new Intl.Collator(document.documentElement.lang || undefined, { numeric: true, sensitivity: 'base' });

    headers.forEach(function (th, column) {
      const type = th.dataset.sort;
      if (type !== 'text' && type !== 'number') return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sort-button';
      while (th.firstChild) button.appendChild(th.firstChild);
      th.appendChild(button);

      button.addEventListener('click', function () {
        const current = th.getAttribute('aria-sort');
        const direction = current === 'ascending' ? 'descending'
          : current === 'descending' ? 'ascending'
          : (type === 'number' ? 'descending' : 'ascending');
        headers.forEach(function (other) { other.removeAttribute('aria-sort'); });
        th.setAttribute('aria-sort', direction);

        const value = function (row) {
          const cell = row.cells[column];
          const raw = cell ? (cell.dataset.sortValue ?? cell.textContent.trim()) : '';
          if (raw === '') return null;
          return type === 'number' ? Number(raw) : raw;
        };
        const rows = Array.from(body.rows);
        rows.sort(function (a, b) {
          const x = value(a);
          const y = value(b);
          if (x === null || y === null) return (x === null) - (y === null);
          const order = type === 'number' ? x - y : collator.compare(x, y);
          return direction === 'ascending' ? order : -order;
        });
        rows.forEach(function (row) { body.appendChild(row); });
      });
    });
  });
}
